import styled from 'styled-components';

export const ActionButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 15px 15px 0px 15px;
  position: relative;

  .action-buttons {
    display: flex;
    gap: 16px;
    align-items: center;
  }

  .action-button {
    background: transparent;
    border: none;
    color: #666;
    font-size: 14px;
    cursor: pointer;
    padding: 4px 8px;
    transition: color 0.2s ease;

    &:hover {
      color: #57069e;
    }

    &:disabled {
      color: #ccc;
      cursor: not-allowed;
    }
  }

  .dropdown-container {
    position: relative;
  }

  .selected-card {
    text-align: center;
    padding: 0px 2px;
    border-radius: 4px;
    font-size: 14px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    white-space: nowrap;
    min-width: 70px;
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 250px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  margin-top: 4px;
  padding: 8px;
`;

export const DropdownItem = styled.div<{
  disabled?: boolean;
  cor?: string;
  corTexto?: string;
}>`
  padding: 12px 16px;
  margin-bottom: 8px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  border-bottom: 1px solid #f0f0f0;
  border-radius: 6px;
  transition: background-color 0.2s ease;
  color: ${(props) => {
    if (props.disabled) return '#ccc';
    if (props.cor) return '#ffffff'; // Texto branco quando há cor de fundo
    if (props.corTexto) return props.corTexto;
    return '#333';
  }};
  background-color: ${(props) => {
    if (props.disabled) return 'transparent';
    if (props.cor) return props.cor;
    return 'transparent';
  }};
  border-left: ${(props) => (props.cor ? `4px solid ${props.cor}` : 'none')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  &:hover {
    background-color: ${(props) => {
      if (props.disabled) return 'transparent';
      if (props.cor) return props.cor;
      return '#f5f5f5';
    }};
    opacity: ${(props) => (props.disabled ? 1 : 0.8)};
  }

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }

  .card-content {
    flex: 1;
  }

  .campo-nome {
    display: block;
    font-weight: 500;
    margin-bottom: 2px;
    color: ${(props) => {
      if (props.disabled) return '#ccc';
      if (props.cor) return '#ffffff'; // Texto branco quando há cor de fundo
      if (props.corTexto) return props.corTexto;
      return 'inherit';
    }};
    text-shadow: ${(props) =>
      props.cor
        ? '-1px -1px 0 rgba(0,0,0,0.5), 1px -1px 0 rgba(0,0,0,0.5), -1px 1px 0 rgba(0,0,0,0.5), 1px 1px 0 rgba(0,0,0,0.5)'
        : 'none'};
  }

  .campo-sinonimo {
    display: block;
    font-size: 12px;
    color: ${(props) => {
      if (props.disabled) return '#ccc';
      if (props.cor) return '#ffffff'; // Texto branco quando há cor de fundo
      if (props.corTexto) return props.corTexto;
      return '#666';
    }};
    opacity: 0.8;
    text-shadow: ${(props) =>
      props.cor
        ? '-1px -1px 0 rgba(0,0,0,0.5), 1px -1px 0 rgba(0,0,0,0.5), -1px 1px 0 rgba(0,0,0,0.5), 1px 1px 0 rgba(0,0,0,0.5)'
        : 'none'};
  }

  .edit-button {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => {
      if (props.cor) return '#ffffff';
      return '#666';
    }};
    transition: all 0.2s ease;
    margin-left: 8px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      color: ${(props) => {
        if (props.cor) return '#ffffff';
        return '#57069e';
      }};
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;
